<ul>
  <ta-subsection-header-item
    *ngFor="let header of subsection.headers; last as isLast"
    [subsectionLink]="subsection.link"
    [header]="header"
    [active]="header.label === activeHeader"
    [isLast]="isLast"
  ></ta-subsection-header-item>
</ul>
